/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MDTypography from "components/MDTypography";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import AddFAQ from "layouts/cmsPage/faqPage/components/AddFAQ";
import FetchTableData from "layouts/cmsPage/faqPage/data/faqTableData";

function FAQPage() {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [severity, setSeverity] = useState("success");

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    setSnackbarOpen(true);
    setRefresh(!refresh);
    setSnackbarMsg("FAQ created successfully!!");
    setSeverity("success");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleFailed = (msg) => {
    setSnackbarMsg(msg);
    setRefresh(!refresh);
    setSnackbarOpen(true);
    setSeverity("error");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox pt={8} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium"></MDTypography>
      </MDBox>
      <MDBox pt={8} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  FAQ
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <AddFAQ onClose={handleClose} onSuccess={handleSuccess} onFailed={handleFailed} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox pt={8} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <FetchTableData onRefresh={refresh} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={severity} sx={{ width: "100%" }}>
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default FAQPage;
